import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';
import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/user.actions';
import * as home from '../../../../actions/process.home.actions';
import { post } from '../../../../api/_basic';


import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Hidden from '@material-ui/core/Hidden';
import Avatar from '@material-ui/core/Avatar';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Refresh from '@material-ui/icons/Refresh';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import AvatarDialog from '../../../dialogs/Avatar';
import Snackbar from '../../../labels/Snackbar';
import Menu from '../Menu';
import Tree from './Tree';

import { CalendarIcon, BlueTickIcon } from '../../../../images/icons/WrapSvg';
import { tzList } from '../../../../const/tz.types';

// eslint-disable-next-line
import style from './_style.css';

function isOk(field) {
    return field === undefined || field.length < 2;
}

function helperText(field, intl) {
    return field === undefined || field.length === 0
        ? intl.formatMessage({ id: 'required' })
        : field.length < 2
            ? intl.formatMessage({ id: 'min_length_2' })
            : '';
}

function isOkEmail(value) {
    return value ? !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) : false;
}

function today() {
    return formatDate(new Date());
}

function formatDate(d) {
    function pad(s) {
        return s < 10 ? '0' + s : s;
    }
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-');
}

function toolbar(handleSummit) {
    return (
        <BlueTickIcon
            key="submmit-post-employee"
            className="hand"
            color="primary"
            onClick={handleSummit}
        />
    );
}

function formatTree(node) {
    return {
        id: parseInt(node.id, 10),
        nombre: node.name,
        hijos: node.children.map((c) => formatTree(c)),
    };
}

class Employee extends React.Component {
    

    constructor(props) {
        super(props);
        console.log(props.id)
        if (props.id) {
            props.loadInfo(props.id);
        }

        console.log(props.info.security.hierarchies);
        this.state = {
            id: randomstring(),
            login: '',
            nombre: '',
            apellidos: '',
            email: '',
            activo: true,
            idCliente: null,
            idioma: 'es',
            fechaAlta: today(),
            tz: 'Europe/Madrid',
            emailThrottle: false,
            error: '',
            cliente: props.info && props.info.security && props.info.security.hierarchies
                    ? formatTree(props.info.security.hierarchies)
                    : {},
            permisos: [],
            selected: undefined,
            foto: undefined,
            avatarDialog: false
        };
    }

    componentDidUpdate() {
        if (this.isCorrect()) {
            const tools = [toolbar(this.handleSummit)];
            this.props.setTools(tools);
        } else {
            this.props.setTools([]);
        }
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.user && nextProps.id) {
            const {
                id,
                login,
                email,
                nombre,
                apellidos,
                activo,
                idCliente,
                fechaAlta,
                emailThrottle,
                idioma,
                tz,
                permisos,
                foto
            } = nextProps.user;
            this.setState({
                id: id,
                login: login ? login : '',
                nombre: nombre ? nombre : '',
                apellidos: apellidos ? apellidos : '',
                email: email ? email : '',
                activo: activo === true ? true : false,
                idCliente: idCliente,
                idioma: idioma ? idioma : 'es',
                fechaAlta: fechaAlta ? formatDate(new Date(fechaAlta.date)) : '',
                tz: tz ? tz : 'Europe/Madrid',
                emailThrottle: emailThrottle === true ? true : false,
                cliente: nextProps.info && nextProps.info.security
                            ? formatTree(nextProps.info.security.hierarchies)
                            : {},
                permisos: permisos ? permisos : [],
                foto: foto ? foto : undefined
            });
        }
    }

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
        */
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleChecked = (event) => {
        this.setState({ [event.target.name]: event.target.checked, edit: true });
    };

    handleDate = (date) => {
        this.setState({ fechaAlta: date });
    };

    handleClose = () => {
        this.setState({ error: '' });
    };

    handlePermisos = (permisos) => {
        console.log(permisos);
        this.setState({ permisos: permisos });
    };

    openAvatarDialog = (event) => {
        this.setState({ avatarDialog: true });
    };

    closeAvatarDialog = (foto) => {
        console.log(foto);
        if (foto) {
            this.setState({ avatarDialog: false, foto: foto });
        } else {
            this.setState({ avatarDialog: false });
        }
    };

    isCorrect = () => {
        const { login, nombre, apellidos, permisos } = this.state;
        return (
            login &&
            login.length > 1 &&
            nombre &&
            nombre.length > 1 &&
            apellidos &&
            apellidos.length > 1 &&
            permisos &&
            permisos.length > 0 && 
            permisos.reduce((arr, p) => {
                arr = arr.concat(
                    p.idrol.map((r) => {
                        return {
                            idlocal: p.idlocal,
                            idusuario: this.props.id ? p.idusuario : -1,
                            idrol: r,
                        };
                    }),
                );
                return arr;
            }, []).length > 0
        );
    };

    handleSummit = () => {
        const {
            id,
            login,
            email,
            nombre,
            apellidos,
            activo,
            fechaAlta,
            emailThrottle,
            idioma,
            tz,
            password,
            permisos,
            foto
        } = this.state;

        const user = {
            login: login,
            nombre: nombre,
            apellidos: apellidos,
            email: email,
            activo: activo,
            idioma: idioma,
            tz: tz,
            emailThrottle: emailThrottle,
            permisos:
                permisos && permisos.length > 0
                    ? permisos.reduce((arr, p) => {
                        arr = arr.concat(
                            p.idrol.map((r) => {
                                return {
                                    idlocal: p.idlocal,
                                    idusuario: this.props.id ? p.idusuario : -1,
                                    idrol: r,
                                };
                            }),
                        );
                        return arr;
                    }, [])
                    : [],
        };
        if (foto) {
            user.foto = foto;
        }
        if (!this.props.id) {
            if (password) {
                user.password = password;
            }
            user.fechaAlta = fechaAlta;
            user.idCliente = this.props.active.idCliente;
            this.props
                .addUser(user)
                .then((r) => {
                    this.props.history.push('/manage/user');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message, errorType: error.type });
                });
        } else {
            user.id = id;
            if (password) {
                user.password = password;
            }
            this.props
                .editUser(user)
                .then((r) => {
                    this.props.history.push('/manage/user');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message, errorType: error.type });
                });
        }
    }

    handleBlur = () => {
        const { nombre, apellidos } = this.state;
        if(!this.props.id && nombre) {
            post(`${process.env.REACT_APP_API}/generarlogin`, { nombre: nombre, apellidos: apellidos })
            .then((r) => {
                console.log(r)
                this.setState({ login : r.codigo })
            })
        }
    }


    Field = (field, name, intl, autoFocus = false, disable = false, handleBlur) => (
        <TextField
            autoFocus={autoFocus}
            fullWidth
            disabled={disable}
            id={name}
            name={name}
            required
            error={isOk(field)}
            helperText={helperText(field, intl)}
            label={intl.formatMessage({ id: 'form_field_name_' + name })}
            className={'flex_full_row'}
            value={field}
            onChange={this.handleChange}
            onBlur={handleBlur}
            margin="normal"
        />
    )

    render() {

        const {
            info,
            login,
            email,
            nombre,
            apellidos,
            activo,
            fechaAlta,
            emailThrottle,
            idioma,
            tz,
            error,
            errorType,
            cliente,
            permisos,
            foto,
            avatarDialog,
        } = this.state;

        const { intl, id, users_is_loading, users_has_errored } = this.props;

        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '64') &&
             info.security.licencias.some((f) => f.id === 152 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (id && users_has_errored.hasErrored) {
            return <Error open type={users_has_errored.hasErrored}  message={users_has_errored.error} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    {users_is_loading && <Loading open opacity />}
                    {error && (
                        <Snackbar
                            open={error}
                            variant={ errorType ? errorType : "error" }
                            text={error}
                            onClose={this.handleClose}
                        />
                    )}
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white showbar'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={2} />
                        </div>
                    </Hidden>
                    <div className={'flex_full bg_white'}>
                        <div className={'flex_full_column padding_bottom_9 height100'}>
                            <div
                                className="flex_full overflow_y_scroll showbar "
                                onScroll={this.handleScroll}
                            >
                                <div
                                    className="width100 bg_ice_blue shadow"
                                    style={{ height: '85px' }}
                                />
                                <div className="flex_full_row center">
                                    <Avatar className={'avatar-user-menu'}>
                                        {foto && (
                                            <img
                                                src={foto}
                                                alt="Preview"
                                                onClick={this.openAvatarDialog}
                                            />
                                        )}
                                        {!foto && (
                                            <AccountCircle
                                                className={'bg_bluish'}
                                                style={{ fontSize: 84 }}
                                                onClick={this.openAvatarDialog}
                                            />
                                        )}
                                    </Avatar>
                                </div>
                                <div className="flex_full_column padding_borders">
                                    <TextField
                                        fullWidth
                                        id={'email'}
                                        name={'email'}
                                        error={isOkEmail(email)}
                                        helperText={
                                            isOkEmail(email)
                                                ? intl.formatMessage({ id: 'email_format_error' })
                                                : ''
                                        }
                                        label={intl.formatMessage({ id: 'form_field_name_email' })}
                                        className={'flex_full_row'}
                                        value={email}
                                        onChange={this.handleChange}
                                        autoComplete="new-email" 
                                        margin="normal"
                                    />
                                    {this.Field(nombre, 'nombre', intl, false, false, this.handleBlur)}
                                    {this.Field(apellidos, 'apellidos', intl, false, false, this.handleBlur)}
                                    <div className={'flex_auto_row center'}>
                                        {this.Field(
                                            login,
                                            'login',
                                            intl,
                                            true,
                                            true, //this.props.id ? true : false
                                        )}
                                        {!this.props.id && <Refresh className="margin_left_6" onClick={this.handleBlur} /> }
                                    </div>
                                    
                                    <div className="flex_full_row align_center">
                                        <TextField
                                            fullWidth
                                            id="password"
                                            name="password"
                                            label={intl.formatMessage({ id: 'change_pin_new' })}
                                            className={'padding_bottom_24 margin_top_9'}
                                            type="password"
                                            autoComplete="new-password" 
                                            margin="normal"
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="flex_full_row margin_top_32 align_center">
                                        <CalendarIcon color="primary" className="margin_right_12" />
                                        <TextField
                                            disabled
                                            id="fechaAlta"
                                            name="fechaAlta"
                                            label={intl.formatMessage({
                                                id: 'form_field_name_register_date',
                                            })}
                                            type="date"
                                            defaultValue={fechaAlta}
                                            onChange={this.handleChange}
                                            className={'flex_full_row'}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="flex_full_row margin_top_32 align_center">
                                        <div className="flex_full_column">
                                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                                <FormattedMessage id="form_field_name_email_throttle" />
                                            </div>
                                        </div>
                                        <div className="flex_auto_column">
                                            <Switch
                                                name={'emailThrottle'}
                                                checked={emailThrottle}
                                                onChange={this.handleChecked}
                                                value="emailThrottle"
                                                color="primary"
                                            />
                                        </div>
                                    </div>
                                    <div className="flex_full_row margin_top_32 align_center">
                                        <div className="flex_full_column">
                                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                                <FormattedMessage id="form_field_name_active_user" />
                                            </div>
                                        </div>
                                        <div className="flex_auto_column">
                                            <Switch
                                                name={'activo'}
                                                checked={activo}
                                                onChange={this.handleChecked}
                                                value="activo"
                                                color="primary"
                                            />
                                        </div>
                                    </div>
                                    <div className="flex_full_row margin_top_32">
                                        <FormControl className="flex_full_row">
                                            <InputLabel htmlFor="idioma">
                                                <FormattedMessage id="form_field_name_language" />
                                            </InputLabel>
                                            <Select
                                                fullWidth
                                                value={idioma}
                                                onChange={this.handleChange}
                                                inputProps={{
                                                    name: 'idioma',
                                                    id: 'idioma-select',
                                                }}
                                            >
                                                <MenuItem value={'es'}>es</MenuItem>
                                                <MenuItem value={'en'}>en</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="flex_full_row margin_top_32">
                                        <FormControl className="flex_full_row">
                                            <InputLabel htmlFor="tz">
                                                <FormattedMessage id="form_field_name_tz" />
                                            </InputLabel>
                                            <Select
                                                value={tz}
                                                onChange={this.handleChange}
                                                inputProps={{
                                                    name: 'tz',
                                                    id: 'tz-select',
                                                }}
                                            >
                                                {tzList.map((t) => (
                                                    <MenuItem key={t.replace('/', '-')} value={t}>
                                                        {t}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="flex_full_row margin_top_32">
                                        {cliente && (
                                            <Tree
                                                idusuario={this.state.id}
                                                cliente={cliente}
                                                permisos={permisos}
                                                onChange={this.handlePermisos}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {avatarDialog && (
                        <AvatarDialog open={true} handleClose={this.closeAvatarDialog} />
                    )}
                </div>
            );
        }
    }
}

Employee.propTypes = {
    intl: intlShape.isRequired,
    user: PropTypes.object.isRequired,
    active: PropTypes.object.isRequired,
    users_has_errored: PropTypes.object.isRequired,
    users_is_loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    return {
        users_has_errored: state.users_has_errored,
        users_is_loading: state.users_is_loading,
        user: state.user,
        active: state.session.info,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
};

Employee = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Employee);

Employee = withRouter(Employee);
Employee = injectIntl(Employee);

export default Employee;



// WEBPACK FOOTER //
// ./src/components/complex/manage/user/Index.js